import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useSession(accessToken: string) {
  const $httpFetch = useHttpFetch()

  return $httpFetch('/auth/gateway', {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  })
}
